export default __webpack_public_path__ + "static/media/corporate2.11dcbdf6.jpg";